<script>
import {getAction, httpAction} from "@/utils/api/manages";

export default {
  name: "circles",
  props: {
    productCategoryId: String,
    productMainTypeId: String
  },
  watch: {
    productCategoryId(val) {
      if (val) this.getCircleList()
    }
  },
  data() {
    return {
      type: null,
      circleList: [],
      circleInfo: {
        icon: null, // 图标
        name: null, // 圈子名称
        membernum: null,// 成员人数
        fid: null, // 圈子id
        posts: null, // 帖子数
        description: null, // 圈子介绍
      },
      isLoading: false,
    }
  },
  created() {
    const {type} = this.$route.query
    this.type = type
    this.getCircleList()
  },
  methods: {
    // 获取圈子数据
    getCircleList() {
      this.isLoading = true
      httpAction({
        url: Discuz_url + "plugin.php?id=qidaoData:api&m=getGroup",
        method: 'get',
        params: {
          type: this.type === '0' ? 'product3' : 'product2',
          productMainTypeId: this.productMainTypeId,
          // productCategoryId: this.productCategoryId
        },
        // 不携带token
        noToken: true,
      }).then(res => {
        if (res.data?.length) {
          this.setCircleInfo(res.data[0])
        } else {
          this.resetCircleInfo()
        }
        this.circleList = res.data ?? []
      }).finally(() => {
        this.isLoading = false
      })
    },
    setCircleInfo(item) {
      const {
        base: {description, icon, membernum, fid},
        posts,
        name,
        rank,
        threads,
        todayposts,
        yestodayposts
      } = item
      this.circleInfo = {
        icon,
        name,
        membernum,
        fid,
        posts,
        description
      }
    },
    joinCircle(fid) {
      if (!fid) this.$message.error('暂无圈子！')
      window.open("https://dis.qidao123.com/forum.php?mod=group&fid=" + fid)
    },
    resetCircleInfo() {
      this.circleInfo = {
        icon: null, // 图标
        name: null, // 圈子名称
        membernum: null,// 成员人数
        fid: null, // 圈子id
        posts: null, // 帖子数
        description: null, // 圈子介绍
      }
    }
  },
}
</script>

<template>
  <div class="circle">
    <div class="list">
      <div class="circlet-head colorLine">
        <h2 class="title">圈子列表</h2>
      </div>
      <ul class="listMain" v-if="circleList.length">
        <li class="list-item" v-for="(item, index) in circleList" @click="setCircleInfo(item)">
          <img class="icon" v-if="item.base.icon" :src="item.base.icon" :alt="item.name">
          <img v-else class="icon" src="https://images.qidao123.com/static/none.png" :alt="item.name"
               style="background:var(--swiper-theme-color) ">
          <span class="name">{{ item.name }}<i class="el-icon-caret-bottom arrow" v-if="item.fid===circleInfo.fid "></i></span>
          <span class="posts">发帖：{{ item.posts }}</span>
        </li>
      </ul>
      <div class="empty" v-else>暂无内容</div>
    </div>
    <div class="circleInfo" v-if="circleInfo.fid&&circleInfo.fid !==0">
      <div class="circlet-head"  @click="joinCircle(circleInfo.fid)">
        <h2 class="title">
          <img class="icon" v-if="circleInfo.icon" :src="circleInfo.icon" :alt="circleInfo.name">
          <img class="icon" v-else src="https://images.qidao123.com/static/none.png"
               style="background:var(--swiper-theme-color) " :alt="circleInfo.name">
          {{ circleInfo.name }}
        </h2>
        <div class="myBtn el-icon-circle-plus" >加入圈子</div>
      </div>
      <div class="infoMain">
        <span class="information">成员：{{ circleInfo.membernum }}</span>
        <span class="information">发帖：{{ circleInfo.posts }}</span>
        <p class="introduced">
          <span style="color: initial">圈子介绍：</span>
          {{ circleInfo.description || '暂无介绍' }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.circle {
  padding: 15px 15px 20px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .myBtn {
    cursor: pointer;
    color: var(--swiper-theme-color);
  }

  .empty {
    text-align: center;
    line-height: 40px;
    color: #999999;
    margin-bottom: -10px;
  }

  .circlet-head {
    display: flex;
    justify-content: space-between;
    position: relative;
    align-items: center;
    margin-bottom: 15px;

    &.colorLine::after {
      content: '';
      display: block;
      height: 100%;
      width: 4px;
      position: absolute;
      left: 0;
      background-color: var(--swiper-theme-color);
      border-radius: 4px;
    }

    .title {
      font-size: 16px;
      color: #232f3e;
      padding-left: 15px;
      font-weight: bold;
      cursor: pointer;

      .icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .list {
    margin-bottom: 10px;

    .listMain {
      padding-left: 15px;
      display: flex;
      flex-direction: column;
      gap: 15px;
      padding-bottom: 7px;
      max-height: 175px;
      overflow: auto;


      .list-item {
        display: flex;
        gap: 5px;
        cursor: pointer;

        .icon {
          width: 18px;
          height: 20px;
          border-radius: 3px;
        }

        .name {
          font-size: 13px;
          flex: 1;

          .arrow{
            font-size: 14px;
            color: var(--swiper-theme-color);
            font-weight: bold;
            padding-left: 10px;
          }
        }

        .posts {
          font-size: 13px;
          width: 80px;
          color: #999999;
        }
      }
    }

  }

  .circleInfo {
    .title {
      font-size: 14px;
      color: #232f3e;
    }
    .infoMain {
      .information {
        display: inline-flex;
        margin-right: 20px;
        color: #999999;
      }

      .introduced {
        color: #666666;
        margin-top: 10px;
        line-height: 1.5em;
      }
    }
  }
}
</style>